"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronLeftIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ChevronLeftIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M10.9235358,15.2551018 C8.85020664,13.1954084 7.15384615,11.5055932 7.15384615,11.4999578 C7.15384615,11.4798291 14.6937237,4 14.7140131,4 C14.7254013,4 15.1059442,4.36886802 15.5596661,4.81970686 L16.3846154,5.63941355 L13.4246304,8.57995247 L10.4646455,11.5204916 L13.4140591,14.450528 L16.3634712,17.3805656 L15.5493489,18.190282 C15.1015811,18.6356262 14.7257759,19 14.714226,19 C14.7026761,19 12.9968649,17.3147951 10.9235358,15.2551018 Z" }))); };
exports.ChevronLeftIcon = ChevronLeftIcon;
